export type GoalProgressScore =
  | 'Improving'
  | 'Declining'
  | 'Unchanged'
  | 'N/A'
  | '0%'
  | '10%'
  | '20%'
  | '30%'
  | '40%'
  | '50%'
  | '60%'
  | '70%'
  | '80%'
  | '90%';

/**
 * Progress score recorded on a patient goal for a visit.
 */
/**
 * Array of all GoalProgressScore values.
 * Progress score recorded on a patient goal for a visit.
 */
export const GOALPROGRESSSCORE_VALUES: readonly GoalProgressScore[] = [
  'Improving',
  'Declining',
  'Unchanged',
  'N/A',
  '0%',
  '10%',
  '20%',
  '30%',
  '40%',
  '50%',
  '60%',
  '70%',
  '80%',
  '90%',
] as const;
